<template>
  <SidebarFixed v-if="!sidebar.showMobileSideBar"></SidebarFixed>
  <SidebarFloat v-else></SidebarFloat>
  <!-- {{ sidebar.sidebarMobile }} -->
	<!-- <div :class="['sidebar', { 'is-scroll': !sidebar.collapse }]">
		<el-menu
			class="sidebar-el-menu"
			:default-active="onRoutes"
			:collapse="sidebar.collapse"
			text-color="#BED7F5"
			active-text-color="#ffffff"
			unique-opened
			router
		>
			<template v-for="item in menus">
				<template v-if="item.subs">
					<el-sub-menu :index="item.index" :key="item.index">
						<template #title>
							<el-icon>
								<Folder />
							</el-icon>
							<span>{{ item.title }}</span>
						</template>
						<template v-for="subItem in item.subs">
							<el-menu-item :index="subItem.index">
								<el-icon>
									<Document />
								</el-icon>
								<span>{{ subItem.title }}</span>
							</el-menu-item>
						</template>
					</el-sub-menu>
				</template>
				<template v-else>
					<el-menu-item :index="item.index" :key="item.index">
						<el-icon>
							<Document />
						</el-icon>
						<template #title>{{ item.title }}</template>
					</el-menu-item>
				</template>
			</template>
		</el-menu>
	</div> -->
</template>

<script setup>
	import SidebarFixed from "./sidebarFixed.vue";
	import SidebarFloat from "./sidebarFloat.vue";

	import { computed } from "vue";
	import { useSidebarStore } from "../stores/sidebar";

	import { useRoute } from "vue-router";
	import menus from "../assets/js/menu";

	const route = useRoute();
	const onRoutes = computed(() => {
		return route.path;
	});

  const sidebar = useSidebarStore();
  //console.log(sidebar.showMobileSideBar,'0000000000',sidebar.collapse)
</script>

<style lang="scss" scoped>
	.sidebar {
		display: block;
		position: fixed;
		z-index: 10;
		left: 0;
		top: 70px;
		bottom: 0;
    // border-radius: 0 0 50px 0; 
	
    &.is-scroll{
	    overflow-y: scroll;
      scrollbar-width: none; /* Firefox 支持 */
      -ms-overflow-style: none;  /* IE/Edge 支持 */
    }
    /* 隐藏滚动条轨道 (Chrome, Safari, Opera) */
    &.is-scroll::-webkit-scrollbar {
      display: none;
    }
		> p {
			position: absolute;
			bottom: 20px;
			left: 50%;
			transform: translateX(-50%);
			color: #bfcbd9;
		}
	}

	.sidebar::-webkit-scrollbar {
		width: 0;
	}

	.sidebar-el-menu:not(.el-menu--collapse) {
		width: 225px;
    border: none;
	}

	.sidebar > ul {
		height: 100%;
	}

	.el-sub-menu .el-icon {
		font-size: 1em;
	}
  .el-menu--collapse{
    width: 0;
    display: none;
  }
</style>
